import type { Coding } from "@medplum/fhirtypes";

import { Systems } from "../enums/systems";

export const CUSTOM_TAG: Coding = {
  system: Systems.QH,
  code: "custom",
};
